<template>
  <Layout class="g-wrapper g-vertical-block">
    <Content class="g-main-wrapper g-vertical-block">
      <Row :gutter="12">
        <Col span="24">
          <Tabs :value="currentRoute" @on-click="changeRouter">
            <TabPane name="derivativelist" label="视频任务管理"></TabPane>
          </Tabs>
        </Col>
      </Row>
      <div class="c-content">
        <router-view />
      </div>
    </Content>
  </Layout>
</template>
<script>
export default {
  name: 'ShutdownDefault',
  data() {
    return {
      currentRoute: '',
      access: this.$store.state.accessAuth
    }
  },
  methods: {
    changeRouter(name) {
      this.$router.replace({ name })
    },
    getCurrent() {
      this.currentRoute = this.$route.name
      if (this.$route.name === 'derivative') this.changeRouter('derivativelist')
    }
  },
  watch: {
    $route: {
      handler() {
        this.getCurrent()
      },
      deep: true
    }
  },
  created() {
    this.getCurrent()
  }
}
</script>
